export class careers {
    name: string;
    surname:string;
    comapany:string;
    jobRole:string;
    email:string;
    phone:string;
    curriculum:File;
    message:string;
    authorization:boolean;
    captcha:any;

    constructor(data?: Partial<careers>) {
        Object.assign(this, data);
      }
}